import React from "react";
import RespondentTerminalPage from "../components/ending/RespondentTerminalPage";

const TerminateV2 = () => {
  return (
    <RespondentTerminalPage
      variant="terminate"
      message="Unfortunately, you do not qualify to continue with this survey at this time."
    />
  );
};

export default TerminateV2;
